/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/react-in-jsx-scope */
import { DealerProfileType, } from '@masterffl/dealer-profile-component';
import { useDispatch, useSelector } from "react-redux";
import { setIsProcessCompleted, setRefreshStatus, updateLOALicensePath } from '@/redux/app-slice';
import mime from 'mime-types';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getIsProcessCompleted, getUserEmail } from '@/redux/app-selectors';
import { RootState } from '@/redux/store';
import { callToGetDealerDetail, callToGetOCRStepFunctionDetailsV2, callToManualReviewRequest, certificateWorkflowInitialState, setCallOcrStepFunctionApi, setIsManualReviewRequested, setIsOCRLoading, setOcrStepFunctionStatusV2 } from '../ducks/slice';
import { useDropzone } from 'react-dropzone/.';
import { Box, Button, FormControl, FormLabel, Image, Text, Spinner, Select } from '@chakra-ui/react';
import { fileUploadDescription, fileUploadMessage, LOAUnderReviewMessage } from "@/utils/constants";
import ModalComponent from '@/common/Modal';
import path from 'path';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
import { getIsManualReviewRequested, getIsOCRLoading, getOcrStepFunctionStatus } from '../ducks/selectors';
import Steppers from '../modals/Steppers';
import DocumentValidationError from '../modals/document-validation-error';
import DocumentValidationInstruction from '../modals/document-validation-instruction';
import { v4 as uuidv4 } from "uuid";
import { uploadData } from 'aws-amplify/storage';

interface LOAUploadModalInterface {
  data: DealerProfileType
  licenseKeyForLOA: string;
  setLicenseKeyForLOA: (value: string) => void;
}
interface LOAFormProps {
  files: any;
  onFileChange: (file: any) => void;
  isFileUploaded: boolean;
  setErrorStepIndex: (index: number) => void;
  setSuccessStepIndex: (index: number) => void;
  setActiveStepIndex: (index: number) => void;
}

interface LicensesOption {
  licenseKey: string;
  fullLicenseKey: string;
}

export function LOAForm({ files, onFileChange, isFileUploaded, setErrorStepIndex, setActiveStepIndex, setSuccessStepIndex }: LOAFormProps) {
  // Accept file that is of type image/pdf
  const { acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive, open: openFileDialog } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
      "image/jpg": [],
      "application/pdf": [],
    },
    noClick: true,
    noKeyboard: true,
    onDrop: (acceptedFiles: any) => {
      if (acceptedFiles.length) {
        onFileChange(acceptedFiles.map((file: any) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ))
        setErrorStepIndex(0);
        setSuccessStepIndex(1);
        setActiveStepIndex(2);
      }
    },
    multiple: false,
  })

  // Error for rejecting the file and compute the rejected file size
  const fileRejectionItems = fileRejections.map(({ file, errors }: any) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map((e: any) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));


  // Preview the file uploaded
  const thumbs = files.map((file: any) => {
    return (
      <div className="clear-both" key={file.name}>
        {file.type === "application/pdf" ? (
          <iframe
            src={file.preview}
            width="100%"
            className="docs-iframe"
            id="file-preview-iframe"
          ></iframe>
        )
          :
          <Image
            src={file.preview}
            alt="Preview"
            style={{ width: '100%', height: 'auto' }}
            className="image-preview"
          />
        }
      </div>
    );
  });
  return (
    <Box className="sot_form_wrapper" sx={{ display: 'flex', flexDirection: 'column', flexGrow: '1', overflow: 'auto' }}>
      <Box className="upload_file_container" sx={{ overflow: 'auto' }}>
        {/* On click upload button, show progress bar for file upload status  */}
        {isFileUploaded ?
          <Box className="upload_file_progress_wrapper">
            <Spinner
              thickness={'4px'}
              speed="0.65s"
              emptyColor={'gray.200'}
              color="#0C1E46"
              size={'xl'}
            />
            <Text>Please wait while the file is uploading</Text>
          </Box>
          :
          files && files.length > 0 && files[0].size / (1024 * 1024) <= 8 ?
            (
              <>
                <Box className="file-preview-modal">
                  <Box>{thumbs}</Box>
                </Box>
              </>
            ) :
            <Box className="upload_file_wrapper" onClick={openFileDialog}>
              <Image className="upload_file_icon" src="/images/ui/upload.svg" alt="upload-icon" />
              <Box className="upload_file_description_text" {...getRootProps()}>
                <FormControl>
                  <FormLabel style={{ textAlign: 'center', width: '60%', margin: 'auto' }} >
                    Click here to upload a file (File format- jpeg/png/pdf)</FormLabel>
                  <input type='file' {...getInputProps()} style={{ display: 'none' }} />
                  {fileRejectionItems.length ? (
                    <Text style={{ color: 'red', fontWeight: 'bold' }}>
                      Please select file from one of the above types.
                    </Text>
                  ) : (<></>)}
                  {files && files.length > 0 && files[0].size / (1024 * 1024) > 8 && (<Text style={{ color: 'red', fontWeight: '500', marginTop: '4px' }} >*Please upload file with size less than 8MB*</Text>)
                  }
                </FormControl>
              </Box>
            </Box>
        }

      </Box>
    </Box>
  )
}

const LOAUploadModal = ({ data, licenseKeyForLOA, setLicenseKeyForLOA }: LOAUploadModalInterface) => {
  const dispatch = useDispatch()
  const params: any = useParams();
  const [files, setFiles] = useState<any>([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [licenses, setLicenses] = useState<LicensesOption[]>([])
  const processCompleted = getIsProcessCompleted();
  const refreshStatus = useSelector(
    (state: RootState) => state.app.refreshStatus
  )
  const userEmail = getUserEmail()
  const [isFileUploadedSuccess, setIsFileUploadedSuccess] = useState(false)
  const [activeStepIndex, setActiveStepIndex] = useState(1);
  const [successStepIndex, setSuccessStepIndex] = useState(0);
  const [errorStepIndex, setErrorStepIndex] = useState(0);
  const [isDocumentValidationError, setIsDocumentValidationError] = useState(false)
  const [isReviewPending, setIsReviewPending] = useState(false)
  const ocrStepFunctionStatus: any = getOcrStepFunctionStatus();
  const isOcrLoading = getIsOCRLoading();
  const isManualReviewRequested = getIsManualReviewRequested();
  const [documentId, setDocumentId] = useState('');

  useEffect(() => {
    if (data?.licenses[0]?.licenseKey) {
      const licensesDetails = data.licenses.map((license: { licenseKey: string, fullLicenseKey: string }) => {
        return { licenseKey: license.licenseKey, fullLicenseKey: license.fullLicenseKey }
      })
      setLicenses(licensesDetails)
    }
  }, [data])

  useEffect(() => {
    if (licenseKeyForLOA) {
      logAnalyticsEvent(analyticsEvents.loa_Upload);
    }
  }, [licenseKeyForLOA])

  const onCloseHandler = () => {
    setLicenseKeyForLOA("");
    setDocumentId('')
    setIsFileUploadedSuccess(false)
    setActiveStepIndex(1)
    setSuccessStepIndex(0)
    setErrorStepIndex(0)
    setIsDocumentValidationError(false)
    dispatch(setIsProcessCompleted(false))
    setIsFileUploaded(false)
    setFiles([])
    setIsLoading(false)
    setTimeout(() => {
      setIsReviewPending(false);
      dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
      dispatch(setIsManualReviewRequested(false));
  }, 200);
    if (refreshStatus) {
      dispatch(callToGetDealerDetail(params?.dealerId));
      dispatch(setRefreshStatus(false));
    }
  }

  useEffect(() => {
    if (isFileUploadedSuccess) {
      setIsLoading(false)
    }
    if (refreshStatus) {
      setIsLoading(false)
      setIsFileUploaded(false)
    }
  }, [isFileUploadedSuccess, refreshStatus])

  useEffect(() => {
    setDocumentId('')
    dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
    setIsFileUploaded(false)
    setFiles([])
    setIsLoading(false)
    setIsFileUploadedSuccess(false)
    setActiveStepIndex(1)
    setSuccessStepIndex(0)
    setErrorStepIndex(0)
    setIsReviewPending(false);
    setIsDocumentValidationError(false)
    dispatch(setIsManualReviewRequested(false));
  }, [licenseKeyForLOA])

  useEffect(() => {
    if (isManualReviewRequested) {
      setErrorStepIndex(0);
      setIsReviewPending(true)
      setIsLoading(false)
      setIsDocumentValidationError(false)
    }
  }, [isManualReviewRequested]);

  useEffect(() => {
    if (ocrStepFunctionStatus?.status == null) {
      setIsLoading(false)
      setIsFileUploadedSuccess(false)
      setActiveStepIndex(1)
      setSuccessStepIndex(0)
      setErrorStepIndex(0)
      setIsReviewPending(false);
      setIsDocumentValidationError(false)
      setDocumentId('')
      return
    }
    if (ocrStepFunctionStatus?.status !== 0 && ocrStepFunctionStatus?.status !== null) {
      dispatch(setCallOcrStepFunctionApi(false));
      if (ocrStepFunctionStatus.status === 13 ||
        ocrStepFunctionStatus.status === 54 ||
        ocrStepFunctionStatus.status === 54 ||
        ocrStepFunctionStatus.status === 14 ||
        ocrStepFunctionStatus.status === 33 ||
        ocrStepFunctionStatus.status === 16 ||
        ocrStepFunctionStatus.status === 15 ||
        ocrStepFunctionStatus.status === 51 ||
        ocrStepFunctionStatus.status === 52
      ) {
        setIsDocumentValidationError(true);
        setSuccessStepIndex(2);
        setErrorStepIndex(3);
        // dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
      } else {
        setSuccessStepIndex(2);
        setActiveStepIndex(3)
        setIsReviewPending(true)
        setIsDocumentValidationError(false);
        dispatch(callToGetDealerDetail(params?.dealerId));
        dispatch(setRefreshStatus(false));
        setIsLoading(false)
      }
    } else if (ocrStepFunctionStatus) {
      if (ocrStepFunctionStatus.status === 0) {
        dispatch(setCallOcrStepFunctionApi(false))
        setSuccessStepIndex(3)
        setIsLoading(false)
        setIsFileUploaded(false)
        setIsFileUploadedSuccess(true)
        dispatch(callToGetDealerDetail(params?.dealerId));
        dispatch(setRefreshStatus(false));
        setDocumentId('')
      }
    }
  }, [ocrStepFunctionStatus]);


  // create an S3 bucket, upload file and track uploading progress
  const uploadLOAInS3 = async (files: any, license: string) => {
    try {
      if (files && license) {
        setSuccessStepIndex(2);
        setActiveStepIndex(3);
        const document_id: any = uuidv4();
        const contentType = mime.lookup(files[0].path.split('.').pop() as string) ||
          'application/octet-stream';
        const res = await uploadData({
          path: `${document_id}/${files[0].name}`,
          data: files[0],
          options: {
            bucket: "licenseReader",
            contentType: contentType,
            metadata: {
              source: "ffl360",
              documentType: "loa", 
              document_type: 'loa',
              document_id: document_id,
              email: userEmail,
              license_key: data?.licenses?.find((record: any) => record?.licenseKey === data.primaryInboundDetails.licenseKey)?.fullLicenseKey || "",
            },
          }
        }).result;
        if (res.path) {
          dispatch(setIsOCRLoading(true));
          dispatch(setCallOcrStepFunctionApi(true));
          dispatch(callToGetOCRStepFunctionDetailsV2({ clientDocumentId: document_id }));
          setDocumentId(document_id)
        }
        const fileName = path.basename(files[0].path);
        console.log("fileName : ", fileName);
        dispatch(setIsProcessCompleted(!!res.path))
      }
    } catch (error) {
      console.log({ error });
      setLicenseKeyForLOA("");
      setDocumentId('')
      dispatch(setRefreshStatus(true))
      setDocumentId('')
    }
  }

  const onUploadNewFile = () => {
    dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
    setIsFileUploaded(false)
    setFiles([])
    setIsLoading(false)
    setIsFileUploadedSuccess(false)
    setActiveStepIndex(1)
    setSuccessStepIndex(0)
    setErrorStepIndex(0)
    setIsReviewPending(false);
    setIsDocumentValidationError(false)
    setDocumentId('')
    dispatch(setIsManualReviewRequested(false));
  }

  const onMannualRequest = () => {
      dispatch(setIsManualReviewRequested(false));
      dispatch(callToManualReviewRequest({ clientDocumentId: documentId }));
  }

  return <>
    <ModalComponent
      title="Upload LOA Document"
      isOpen={!!licenseKeyForLOA}
      onClose={onCloseHandler}
      variant={2}
      className="sot_form_wrapper upload-license-modal"
      // maxWidth={"534"}
      footer={
        isOcrLoading || isLoading || isDocumentValidationError ? <></> :
          (!isFileUploadedSuccess && !isReviewPending) ?
            <Button
              colorScheme="blue"
              background="#0C1E46"
              padding="8px 20px"
              onClick={() => {
                uploadLOAInS3(files, licenseKeyForLOA)
                setIsFileUploaded(true)
                setIsLoading(true)
              }}
              isDisabled={isLoading || isFileUploadedSuccess || files.length === 0 || (files[0]?.size / (1024 * 1024) > 8) || licenseKeyForLOA === ''}
            >
              Upload
            </Button>
            : <Button
              colorScheme="blue"
              background="#0C1E46"
              padding="8px 20px"
              onClick={onCloseHandler}
            >
              Done
            </Button>
      }
    >
      <Box className='Upload-doc-wrapper'>
        <Box className="step_header">
          <Box className="stepperMain">
            <Steppers
              successSteps={successStepIndex}
              activeIndex={activeStepIndex}
              errorIndex={errorStepIndex}
            />
          </Box>
        </Box>

        {
          (isFileUploadedSuccess ?
            <Box className='file_upload_successful'>
              <Image src="/images/ui/success-icon.svg" alt="success-icon" />
              <Text className='file_upload_success_message'>{fileUploadMessage}</Text>
              <Box className='file_upload_success_description'>
                <Text>{fileUploadDescription}</Text>
                <Text>Please check your profile after 15 minutes, if LOA information is not updated kindly contact at support@masterffl.com.</Text>
              </Box>
            </Box>
            :
            <>
              <>
                {isDocumentValidationError ? (
                  <DocumentValidationError documentTypeLabel="LOA" OnUploadNewFile={onUploadNewFile} onMannualRequest={() => onMannualRequest()} />
                ) : (
                  isFileUploaded ? (
                    <DocumentValidationInstruction isReviewPending={isReviewPending}  isManualReviewRequested={isManualReviewRequested} />
                  ) : (
                    <LOAForm
                      files={files}
                      onFileChange={setFiles}
                      isFileUploaded={isFileUploaded}
                      setErrorStepIndex={setErrorStepIndex}
                      setSuccessStepIndex={setSuccessStepIndex}
                      setActiveStepIndex={setActiveStepIndex}
                    />
                  )
                )}
              </>
            </>)
        }
      </Box>
    </ModalComponent>
  </>


}

export default LOAUploadModal;